import { SlicesUIElement, html } from '../element/element';
import { StringConverter, BooleanConverter } from 'html-element-property-mixins/src/utils/attribute-converters';
import { css } from './icon.css.js';

/**
 * 
 * @element slicesui-icon
 * 
 * @prop {String} icon - Icon to use. See material icons for full reference.
 * @attr {String} icon
 * 
 */

export class SlicesUIIcon extends SlicesUIElement {

  static get properties() {
    return { 
      
      icon: {
        observe: true,
        DOM: true,
        fromAttributeConverter: StringConverter.fromAttribute,
      },

      loaded: {
        observe: true,
        DOM: true,
        reflect: true,
        fromAttributeConverter: BooleanConverter.fromAttribute,
        toAttributeConverter: BooleanConverter.toAttribute,
      }

    };
  }

  static get propertiesChangedHandlers() {
    return {
      render: ['icon', 'loaded']
    };
  }

  constructor() {
    super();
    this._loadFont().then(() => window.requestAnimationFrame(() => this.loaded = true));
  }

  async _loadFont() {
      
    if('FontFace' in window && 'fonts' in document ) {
      const materialIconFont = new FontFace('Material Icons', 'url(https://fonts.gstatic.com/s/materialicons/v50/flUhRq6tzZclQEJ-Vdg-IuiaDsNcIhQ8tQ.woff2)');
      materialIconFont.loaded.then(() => {
        document.fonts.add(materialIconFont);
        return;
      });
      materialIconFont.load();

    } else {
      if(document.querySelector('.slices-material-fonts')) return;
      const style = document.createElement('style');
      document.head.appendChild(style);
      style.classList.add('slices-material-fonts');
      const res = await fetch('https://fonts.gstatic.com/s/materialicons/v50/flUhRq6tzZclQEJ-Vdg-IuiaDsNcIhQ8tQ.woff2');
      const txt = await res.text();
      style.innerHTML = txt;
    }
    
  }

  /**
   * @private
   */
  get template() {
    return html`
      <style>${css}</style>
      ${this.icon}
    `;
  }

}

window.customElements.define('slicesui-icon', SlicesUIIcon);